<template>
    <div class="bg-white p-6 rounded-lg shadow-md max-w-lg mx-auto">
        <h2 class="text-xl font-bold text-gray-900 mb-4">{{ $translate('delete_account') }}</h2>
        <p class="text-gray-700 mb-6">
            {{ $translate('delete_account_message') }}
            <a href="mailto:info@zakonyprolidi.cz" class="text-blue-600 hover:text-blue-800">info@zakonyprolidi.cz</a>.
            <br>
            {{ $translate('delete_account_soon') }}
        </p>
        <div class="flex justify-end">
            <button @click="goToSettings"
                class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg">
                {{ $translate('back_to_settings') }}
            </button>
        </div>
    </div>
</template>

<script>
import { useRouter } from 'vue-router';
import { getSystemPath } from '@/utils/helper';

export default {
    name: 'AccountDelete',
    setup() {
        const router = useRouter();

        const goToSettings = () => {
            router.push({
                path: `/${getSystemPath('account')}/${getSystemPath('settings')}`,
            });
        };

        return {
            goToSettings,
        };
    },
};
</script>

<style scoped>
a {
    transition: color 0.3s ease;
}

button {
    transition: background-color 0.3s ease;
}
</style>